import React, { useEffect, useState } from 'react';
import { Plus, X, Edit2, Truck, Trash2 } from 'lucide-react';
import api from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { puoFare } from '../../utils/permessi';

const emptyForm = { ragione_sociale:'', partita_iva:'', email:'', telefono:'', indirizzo:'', note:'' };

export default function Suppliers() {
  const { user } = useAuth();
  const puoCreare     = puoFare(user, 'fornitori', 'create');
  const puoModificare = puoFare(user, 'fornitori', 'edit');
  const puoEliminare  = puoFare(user, 'fornitori', 'delete');
  const [suppliers, setSuppliers] = useState([]);
  const [showPanel, setShowPanel] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);

  const load = () => api.get('/suppliers').then(r => setSuppliers(r.data));
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editing) await api.put(`/suppliers/${editing.id}`, form);
    else await api.post('/suppliers', form);
    setShowPanel(false); setEditing(null); setForm(emptyForm); load();
  };

  const openEdit = (s) => { setEditing(s); setForm({ ragione_sociale:s.ragione_sociale, partita_iva:s.partita_iva||'', email:s.email||'', telefono:s.telefono||'', indirizzo:s.indirizzo||'', note:s.note||'' }); setShowPanel(true); };

  const handleDelete = async (s) => {
    if (!window.confirm(`Eliminare il fornitore "${s.ragione_sociale}"?`)) return;
    try {
      await api.delete(`/suppliers/${s.id}`);
      load();
    } catch(e) {
      alert(e.response?.data?.error || 'Errore durante l\'eliminazione');
    }
  };

  return (
    <div style={{ display:'flex',gap:'20px' }}>
      <div style={{ flex:1 }}>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'20px' }}>
          <div><h1 style={{ fontFamily:"'Barlow Condensed'",fontSize: 'var(--font-size-title)',fontWeight:'800',letterSpacing:'2px' }}>FORNITORI</h1><p style={{ color:'var(--text-dim)',fontSize:'var(--font-size-sm)',marginTop:'4px' }}>{suppliers.length} fornitori</p></div>
          {puoCreare && <button style={{ display:'flex',alignItems:'center',gap:'8px',background:'#F4600C',color:'#fff',border:'none',borderRadius:'8px',padding:'11px 18px',fontSize:'var(--font-size-xs)',fontWeight:'700',cursor:'pointer' }} onClick={() => { setEditing(null); setForm(emptyForm); setShowPanel(true); }}><Plus size={15}/> NUOVO FORNITORE</button>}
        </div>
        <div style={{ display:'flex',flexDirection:'column',gap:'8px' }}>
          {suppliers.map(s => (
            <div key={s.id} style={{ background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:'10px',padding:'14px 20px',display:'flex',alignItems:'center',gap:'14px' }}>
              <div style={{ width:'40px',height:'40px',background:'#3B82F620',border:'1px solid #3B82F630',borderRadius:'8px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0 }}><Truck size={16} color="#3B82F6"/></div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:'700',fontSize:'var(--font-size-sm)' }}>{s.ragione_sociale}</div>
                <div style={{ color:'var(--text-dim)',fontSize:'var(--font-size-xs)',marginTop:'2px' }}>{s.email} {s.telefono && `· ${s.telefono}`} {s.partita_iva && `· P.IVA: ${s.partita_iva}`}</div>
              </div>
              {puoModificare && <button style={{ background:'var(--bg-input)',border:'1px solid var(--border2)',borderRadius:'6px',padding:'7px 9px',color:'var(--text-muted)',cursor:'pointer' }} onClick={() => openEdit(s)}><Edit2 size={13}/></button>}
              {puoEliminare && <button style={{ background:'#FEE4E2',border:'1px solid #FCA5A5',borderRadius:'6px',padding:'7px 9px',color:'#EF4444',cursor:'pointer' }} onClick={() => handleDelete(s)}><Trash2 size={13}/></button>}
            </div>
          ))}
          {suppliers.length === 0 && <div style={{ textAlign:'center',color:'var(--text-dim)',padding:'40px' }}>Nessun fornitore</div>}
        </div>
      </div>
      {showPanel && (
        <div style={{ width:'320px',flexShrink:0,background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'12px',height:'fit-content',position:'sticky',top:'20px' }}>
          <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid var(--border)' }}>
            <span style={{ fontFamily:"'Barlow Condensed'",fontSize:'var(--font-size-sm)',fontWeight:'700',letterSpacing:'2px' }}>{editing?'MODIFICA':'NUOVO'} FORNITORE</span>
            <button style={{ background:'transparent',border:'none',color:'var(--text-dim)',cursor:'pointer' }} onClick={() => setShowPanel(false)}><X size={16}/></button>
          </div>
          <form onSubmit={handleSubmit} style={{ padding:'20px',display:'flex',flexDirection:'column',gap:'12px' }}>
            {[['ragione_sociale','RAGIONE SOCIALE *',true],['partita_iva','PARTITA IVA',false],['email','EMAIL',false],['telefono','TELEFONO',false],['indirizzo','INDIRIZZO',false]].map(([k,l,req]) => (
              <div key={k} style={{ display:'flex',flexDirection:'column',gap:'5px' }}>
                <label style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'var(--text-dim)' }}>{l}</label>
                <input style={{ background:'var(--bg-input)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'8px 12px',color:'var(--text)',fontSize:'var(--font-size-sm)',outline:'none' }} value={form[k]} onChange={e => setForm(f=>({...f,[k]:e.target.value}))} required={req} />
              </div>
            ))}
            <div style={{ display:'flex',gap:'10px',marginTop:'8px' }}>
              <button type="button" style={{ background:'var(--border)',color:'var(--text)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'9px 14px',fontSize:'var(--font-size-xs)',fontWeight:'700',cursor:'pointer' }} onClick={() => setShowPanel(false)}>ANNULLA</button>
              <button type="submit" style={{ background:'#F4600C',color:'#fff',border:'none',borderRadius:'8px',padding:'9px 16px',fontSize:'var(--font-size-xs)',fontWeight:'700',cursor:'pointer',flex:1 }}>{editing?'AGGIORNA':'CREA'}</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
